const areaEn = {
  area: {
    selectArea: "Select Area",
    HongKong: "Hong Kong",
    Singapore: "Singapore",
    Macau: "Macau",
    China: "China",
    Japan: "Japan",
    Korea: "Korea",
    Thailand: "Thailand",
  },
};

export default areaEn;
